module.exports = __webpack_public_path__ + "static/media/ic-more-hover.d7e21ad5.svg";